export const ButtonVariants = {
  animate: {
    x: [0, -10],
    opacity: 1,
    transition: { reverse: Infinity, ease: "easeIn" },
  },
};
